module.exports = __webpack_public_path__ + "static/img/26-2.20280cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/26-2.jpg
// module id = qKU3
// module chunks = 0